import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BannerCarousel from "../components/BannerCarousel";
import Products from "../components/Products";
import Category from "../components/Category";

export default function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);






  return (
    <>
      <style>{`
        *{ box-sizing:border-box; }
        html, body, #root{
          height:100%;
          width:100%;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
        }
        :root{
          --bg:#0b1020;
          --text: rgba(255,255,255,.92);
        }
        body{
          margin: 0;
          background:
            radial-gradient(900px 600px at 10% 10%, rgba(109,91,255,.16), transparent 55%),
            radial-gradient(900px 600px at 90% 25%, rgba(34,211,238,.14), transparent 55%),
            linear-gradient(180deg, #070a16, var(--bg));
          color: var(--text);
        }

        .promo-banner {
          max-width: 1200px;
          margin: 40px auto;
          background: #ffffff;
          border-radius: 24px;
          padding: 40px 20px;
          text-align: center;
          position: relative;
          overflow: hidden;
          box-shadow: 0 15px 50px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.05);
        }

        /* Abstract green wisps/background effect */
        .promo-banner::before {
          content: "";
          position: absolute;
          top: -50%; left: -20%; width: 140%; height: 200%;
          background: radial-gradient(circle at 30% 30%, rgba(22, 163, 74, 0.04) 0%, transparent 60%),
                      radial-gradient(circle at 70% 70%, rgba(22, 163, 74, 0.05) 0%, transparent 60%);
          transform: rotate(-15deg);
          pointer-events: none;
        }

        .promo-ribbon-wrap {
          display: inline-block;
          position: relative;
          padding: 0 40px;
          margin-bottom: 25px;
        }

        .promo-ribbon {
          background: linear-gradient(180deg, #16a34a 0%, #14532d 100%);
          color: #fff;
          padding: 14px 45px;
          font-size: 22px;
          font-weight: 800;
          letter-spacing: 2px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.25);
          text-transform: uppercase;
          position: relative;
          z-index: 2;
        }

        /* The folds behind the ribbon */
        .promo-ribbon::before, .promo-ribbon::after {
          content: "";
          position: absolute;
          top: 10px;
          width: 60px;
          height: 100%;
          background: #15803d;
          z-index: -1;
        }

        .promo-ribbon::before {
          left: -30px;
          transform: skewY(-15deg);
          border-radius: 4px 0 0 4px;
        }

        .promo-ribbon::after {
          right: -30px;
          transform: skewY(15deg);
          border-radius: 0 4px 4px 0;
        }

        /* The little triangle "tail" at the ends */
        .promo-tail-l, .promo-tail-r {
          position: absolute;
          top: 15px;
          width: 40px;
          height: 100%;
          background: #14532d;
          z-index: -2;
        }

        .promo-tail-l {
          left: -50px;
          clip-path: polygon(100% 0, 0 50%, 100% 100%);
        }

        .promo-tail-r {
          right: -50px;
          clip-path: polygon(0 0, 100% 50%, 0 100%);
        }

        .promo-stats {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
          color: #334155;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 35px;
          position: relative;
          z-index: 2;
        }

        .promo-stats span b {
          color: #0f172a;
          font-weight: 800;
          font-size: 20px;
        }

        .promo-btn {
          background: linear-gradient(180deg, #16a34a 0%, #14532d 100%);
          color: #fff;
          border: 1px solid rgba(255,255,255,0.2);
          padding: 16px 70px;
          border-radius: 999px;
          font-size: 19px;
          font-weight: 800;
          cursor: pointer;
          transition: 0.2s;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.15);
          position: relative;
          z-index: 2;
        }

        .promo-btn:hover {
          transform: scale(1.04);
          box-shadow: 0 10px 30px rgba(22, 163, 74, 0.4);
        }

        @media (max-width: 768px) {
          .promo-banner { margin: 24px 15px; padding: 30px 10px; }
          .promo-ribbon { font-size: 16px; padding: 10px 25px; }
          .promo-stats { font-size: 11.5px; gap: 6px; }
          .promo-stats span b { font-size: 14px; }
          .promo-btn { padding: 12px 40px; font-size: 15px; }
          .promo-ribbon::before, .promo-ribbon::after { width: 40px; }
          .promo-ribbon::before { left: -20px; }
          .promo-ribbon::after { right: -20px; }
        }
      `}</style>

      {/* ✅ Restored Banners */}
      <BannerCarousel placement="PRODUCTS_TOP" type="SLIDER" />

      {/* ✅ Category */}
      <Category />

      {/* ✅ Premium Join Banner for Guests (Hidden as requested) */}

      {/* ✅ Products */}
      <Products />
    </>
  );
}
